export default __webpack_public_path__ + "static/media/temperature-icon.8592f0b9.svg";